import { render, staticRenderFns } from "./evaluadorjs-form.vue?vue&type=template&id=2481a4e0&scoped=true"
import script from "./evaluadorjs-form.vue?vue&type=script&lang=js"
export * from "./evaluadorjs-form.vue?vue&type=script&lang=js"
import style0 from "./evaluadorjs-form.vue?vue&type=style&index=0&id=2481a4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2481a4e0",
  null
  
)

export default component.exports